var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var _setupLogger, setupLogger_fn, _setupRequestContext, setupRequestContext_fn, _setupHttpLink, setupHttpLink_fn, _setupOnErrorLink, setupOnErrorLink_fn, _setupClient, setupClient_fn;
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import fetch from "cross-fetch";
import { InMemoryCache, HttpLink, ApolloClient, ApolloLink } from "@apollo/client/core";
export * from "@apollo/client/core";
export { HttpLink, InMemoryCache } from "@apollo/client/core";
export * from "graphql-tag";
import VueApollo from "vue-apollo";
export { default as VueApollo } from "vue-apollo";
class GraphClientNotInitializedError extends Error {
  constructor(message = "GraphQL Client not initialized") {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    Error.captureStackTrace(this);
  }
}
class GraphClientSetupError extends Error {
  constructor(message = "Failed to setup client") {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    Error.captureStackTrace(this);
  }
}
class GraphQLClient {
  constructor(logger, cache) {
    __privateAdd(this, _setupLogger);
    __privateAdd(this, _setupRequestContext);
    __privateAdd(this, _setupHttpLink);
    __privateAdd(this, _setupOnErrorLink);
    __privateAdd(this, _setupClient);
    this.logger = logger;
    this.cache = cache;
  }
  init(config) {
    this.config = config;
    __privateMethod(this, _setupLogger, setupLogger_fn).call(this);
    __privateMethod(this, _setupHttpLink, setupHttpLink_fn).call(this);
    __privateMethod(this, _setupRequestContext, setupRequestContext_fn).call(this);
    __privateMethod(this, _setupOnErrorLink, setupOnErrorLink_fn).call(this);
    __privateMethod(this, _setupClient, setupClient_fn).call(this);
  }
  gql() {
    if (!this.client) {
      throw new GraphClientNotInitializedError();
    }
    return this.client;
  }
}
_setupLogger = new WeakSet();
setupLogger_fn = function() {
  var _a;
  if (!((_a = this.config) == null ? void 0 : _a.logger)) {
    return;
  }
  this.logger = this.config.logger;
};
_setupRequestContext = new WeakSet();
setupRequestContext_fn = function() {
  this.headersLink = setContext((_0, _1) => __async(this, [_0, _1], function* (_, { headers }) {
    var _a;
    let fetchedHeaders = {};
    if ((_a = this.config) == null ? void 0 : _a.requestContextHeaders) {
      fetchedHeaders = yield this.config.requestContextHeaders();
    }
    return {
      headers: __spreadValues(__spreadValues({}, headers), fetchedHeaders)
    };
  }));
};
_setupHttpLink = new WeakSet();
setupHttpLink_fn = function() {
  var _a, _b, _c;
  if ((_a = this.config) == null ? void 0 : _a.httpLink.apolloLink) {
    this.httpLink = this.config.httpLink.apolloLink;
    return;
  }
  this.httpLink = new HttpLink(__spreadValues({
    uri: (_b = this.config) == null ? void 0 : _b.httpLink.graphURL,
    fetch
  }, (_c = this.config) == null ? void 0 : _c.httpLink.options));
};
_setupOnErrorLink = new WeakSet();
setupOnErrorLink_fn = function() {
  var _a, _b;
  if ((_a = this.config) == null ? void 0 : _a.onError) {
    this.onErrorLink = (_b = this.config) == null ? void 0 : _b.onError;
    return;
  }
  this.onErrorLink = onError(() => {
  });
};
_setupClient = new WeakSet();
setupClient_fn = function() {
  var _a;
  if (!this.headersLink) {
    throw new GraphClientSetupError("Failed to setup client with missing headers link");
  }
  if (!this.httpLink) {
    throw new GraphClientSetupError("Failed to setup client with missing http link");
  }
  if (!this.onErrorLink) {
    throw new GraphClientSetupError("Failed to setup client with missing error link");
  }
  this.client = new ApolloClient(__spreadValues({
    link: ApolloLink.from([this.headersLink, this.onErrorLink, this.httpLink]),
    cache: this.cache
  }, (_a = this.config) == null ? void 0 : _a.clientOptions));
};
var graphClient = new GraphQLClient(console, new InMemoryCache());
class GraphQLVueLink {
  static plugin() {
    return VueApollo;
  }
  static createProvider(options) {
    return new VueApollo(__spreadValues({}, options));
  }
}
export { GraphQLClient, GraphQLVueLink, graphClient as default };
//# sourceMappingURL=graphql-client-js.es.js.map
